module.exports = __webpack_public_path__ + "static/media/Soraka_0.e3925977.png";